/**
 * @generated SignedSource<<f03af6c0e3d04c3d2b8524169c1d1cc9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type showPricingGuidance_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item">;
  readonly " $fragmentType": "showPricingGuidance_item";
};
export type showPricingGuidance_item$key = {
  readonly " $data"?: showPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"showPricingGuidance_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "showPricingGuidance_item"
};

(node as any).hash = "7a275eb6a2f2f4807ce8c16e29a56245";

export default node;
